import { useEffect, useState } from 'react'

import FeatureContext, {
  DefaultFeatures,
  FeatureContextFeatureKeys,
  FeatureContextFeatures,
  FeatureContextKeys,
} from './featureContext'

function loadFromSessionStorage() {
  try {
    return JSON.parse(sessionStorage?.getItem('features-context') ?? '')
  } catch (e) {}
  return undefined
}

function saveToSessionStorage(features: FeatureContextFeatures) {
  sessionStorage?.setItem('features-context', JSON.stringify(features))
}

const FeatureProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [features, setFeatures] = useState<FeatureContextFeatures>(
    loadFromSessionStorage() || DefaultFeatures,
  )
  const queryString = window.location.search

  useEffect(() => {
    const urlParams = new URLSearchParams(queryString)
    const keys: FeatureContextFeatureKeys[] = Object.keys(
      FeatureContextKeys,
    ).filter(key => isNaN(Number(key))) as FeatureContextFeatureKeys[]
    for (const key of keys) {
      if (urlParams.has(key)) {
        const value = urlParams.get(key)
        if (features[key]) {
          // when a feature was on - a flag can be used to disable it
          const isDisabled =
            value === 'off' || value === 'false' || value === '0'
          if (isDisabled) {
            console.log('feature disabled', key)
            setFeatures(features => ({
              ...features,
              [key]: false,
            }))
          }
        } else {
          // when a feature was off - a flag can be used to enable it
          const isEnabled =
            value === '' || value === 'on' || value === 'true' || value === '1'
          if (isEnabled) {
            console.log('feature enabled', key)
            setFeatures(features => ({
              ...features,
              [key]: true,
            }))
          }
        }
      }
    }
  }, [features, queryString])

  useEffect(() => {
    saveToSessionStorage(features)
  }, [features])

  return (
    <FeatureContext.Provider value={features}>
      {children}
    </FeatureContext.Provider>
  )
}

export default FeatureProvider
